import React, { useState, useEffect } from 'react';
import OptimizedImage from './OptimizedImage';

/*
 * Full-bleed crossfade carousel for the homepage hero.
 * `position` tunes object-position per image so the subject stays centered
 * no matter how aggressively the 16:9 source gets cropped.
 */
const slides = [
  {
    webpSrc: '/images/optimized/zach1.webp',
    fallbackSrc: '/images/zach1.jpg',
    alt: 'Zach standing beneath a Gothic archway at Oxford',
    position: '50% 34%',
  },
  {
    webpSrc: '/images/optimized/zach2.webp',
    fallbackSrc: '/images/zach2.jpg',
    alt: 'Zach presenting a research poster on heat conduction',
    position: '62% 42%',
  },
  {
    webpSrc: '/images/optimized/zach3.webp',
    fallbackSrc: '/images/zach3.jpg',
    alt: 'Zach running a road race',
    position: '48% 38%',
  },
  {
    webpSrc: '/images/optimized/zach4.webp',
    fallbackSrc: '/images/zach4.jpg',
    alt: 'Zach speaking at the gazebo rededication',
    position: '52% 40%',
  },
];

const INTERVAL = 6000;

const HeroCarousel = () => {
  const [index, setIndex] = useState(0);

  // Advances on its own. Deliberately not paused on hover: the hero fills the
  // viewport, so the cursor sits over it by default and hover-pausing left the
  // carousel frozen on the first slide.
  useEffect(() => {
    const timer = setTimeout(
      () => setIndex((i) => (i + 1) % slides.length),
      INTERVAL
    );
    return () => clearTimeout(timer);
  }, [index]);

  return (
    <div className="hero">
      {slides.map((slide, i) => (
        <div
          key={slide.webpSrc}
          className={`hero-slide ${i === index ? 'is-active' : ''}`}
          aria-hidden={i !== index}
        >
          <OptimizedImage
            webpSrc={slide.webpSrc}
            fallbackSrc={slide.fallbackSrc}
            alt={slide.alt}
            style={{ objectPosition: slide.position }}
            loading={i === 0 ? 'eager' : 'lazy'}
          />
        </div>
      ))}

      <div className="hero-scrim" />

      <div className="hero-content">
        <div className="hero-inner">
          <div className="hero-copy">
            <h1 className="hero-title">Hi, I&rsquo;m Zach.</h1>
            <p className="hero-sub">
              Applied mathematics and computer science at Duke University.
            </p>
          </div>

          <div className="hero-dots" role="tablist" aria-label="Hero images">
            {slides.map((slide, i) => (
              <button
                key={slide.webpSrc}
                type="button"
                role="tab"
                aria-selected={i === index}
                aria-label={slide.alt}
                className={`hero-dot ${i === index ? 'is-active' : ''}`}
                onClick={() => setIndex(i)}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroCarousel;
